import React from "react";
import styled, { keyframes } from "styled-components";

import { Rounded } from "../theme/Rounded";
import { ThemeType } from "../theme/Theme";
import { Flex } from "./Flex";

const SpinAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const StyleSpinner = styled(Flex)`
  border: 3px solid
    ${({ theme, color }) => theme[color as keyof ThemeType] || theme.sub}33;
  border-top-color: ${({ color, theme }) =>
    theme[color as keyof ThemeType] || theme.sub};
  border-radius: ${Rounded.circle};
  animation: ${SpinAnimation} 2s linear infinite;
  height: 100%;
  aspect-ratio: 1;
`;

interface SpinnerProps {
  color?: keyof ThemeType;
  size?: string;
  containerStyle?: React.CSSProperties;
  className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({
  color,
  size = "70%",
  containerStyle,
  className,
}) => {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      height={size}
      style={
        containerStyle
          ? { margin: "auto", aspectRatio: "1", ...containerStyle }
          : { margin: "auto", aspectRatio: "1" }
      }
      className={className}
    >
      <StyleSpinner color={color} />
    </Flex>
  );
};
